"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIAssistComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const SignalService_1 = __importStar(require("@front/services/SignalService"));
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const HtmlStripService_1 = __importStar(require("@front/services/HtmlStripService"));
const client_1 = require("@rws-framework/client");
const assistant_component_types_1 = require("./types/assistant.component.types");
const helpers_1 = require("./helpers");
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => x.isEnabled, (0, fast_element_1.html) `
<div id="ai-assist" class="${x => x.minimized ? 'minimized' : ''} ${x => x.thinking ? ' thinking' : ''}">
    <header>
        <rws-tooltip text="${'ai-assist.info'.t()}">
            <i class="simple-icon-question"></i>
        </rws-tooltip>
        <div class="main-zone">
            <h2>${'ai-assist.header'.t()}</h2>
            <app-loader width="20px" height="20px" block="true" ?hidden="${x => !x.thinking}"></app-loader>
        </div>
        <button class="minimize-btn" @click="${x => x.toggleMinimize()}" title="${x => x.minimized ? 'ai-assist.expand'.t() : 'ai-assist.minimize'.t()}">
            <i class="${x => x.minimized ? 'simple-icon-arrow-up' : 'simple-icon-arrow-down'}"></i>
        </button>
    </header>
    ${(0, fast_element_1.when)(x => !x.minimized, (0, fast_element_1.html) `
    <div class="content">
        <div class="entry-list">
            ${(0, fast_element_1.when)(x => x.entries.length > 0, (0, fast_element_1.html) `
                <div class="entry${x => x.entries[x.entries.length - 1].actions && x.entries[x.entries.length - 1].actions.length > 0 ? ' with-suggestions' : ''}${x => x.entries[x.entries.length - 1].knowledge && x.entries[x.entries.length - 1].knowledge.length ? ' with-knowledge' : ''}" 
                     @click="${x => x.selectEntry(x.entries[x.entries.length - 1])}"
                     title="${x => x.entries[x.entries.length - 1].actions && x.entries[x.entries.length - 1].actions.length > 0 ? 'ai.assist.clickForSuggestions'.t() : ''}">            
                     ${(0, fast_element_1.when)(x => x.entries[x.entries.length - 1].knowledge && x.entries[x.entries.length - 1].knowledge.length, (0, fast_element_1.html) `
                        <span class="knowledge-attached">
                            <i class="simple-icon-paper-clip"></i>
                        </span>
                     `)}
                    <p>${x => x.entries[x.entries.length - 1].text}</p>
                </div>
            `)}
            ${(0, fast_element_1.when)(x => x.entries.length === 0, (0, fast_element_1.html) `
                <div class="no-entries">
                    <p>${'ai-assist.no-entries'.t()}</p>
                </div>
            `)}
        </div>
        
        ${(0, fast_element_1.when)(x => x.activeEntry, (0, fast_element_1.html) `
            <ai-suggestions 
                :suggestions="${x => x.currentSuggestions}"
                :suggestionsContext="${x => x.getSuggestionsContext()}"
                @suggestion-applied="${(x, c) => x.onSuggestionApplied(c.event)}"
                @suggestions-applied="${(x, c) => x.onSuggestionsApplied(c.event)}"
                @modal-close="${x => x.onSuggestionsClose()}"
            ></ai-suggestions>
        `)}
    </div>
    `)}
</div>
`)}`;
require("./styles/layout.scss");
const styles = T.css `:host(.showing-suggestions-fullwidth) {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: auto !important;
  z-index: 1000 !important;
  width: 100vw !important;
  height: calc(100vh - 145px) !important;
  transform: none !important;
}
:host(.showing-suggestions-fullwidth) #ai-assist {
  width: 100% !important;
  height: 100% !important;
  border-radius: 0 !important;
  border: none !important;
  padding: 1rem !important;
  opacity: 1 !important;
  background: white !important;
  max-width: none !important;
}
:host(.showing-suggestions-fullwidth) #ai-assist header {
  display: flex !important;
  border-bottom: 1px solid var(--chat_header_color, #e3e6f0);
  padding-bottom: 1rem !important;
  margin-bottom: 1rem !important;
}
:host(.showing-suggestions-fullwidth) #ai-assist .content {
  height: calc(100% - 4rem) !important;
}
:host(.showing-suggestions-fullwidth) #ai-assist .content .entry-list {
  display: none !important;
}
:host(.showing-suggestions-fullwidth) #ai-assist .content ai-suggestions {
  display: block !important;
  width: 100% !important;
  height: 100% !important;
}

#ai-assist {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: #FFF;
  opacity: 0.4;
  border-radius: 15px;
  border: 1px solid var(--chat_header_color, #e3e6f0);
  padding: 0.5rem;
}
#ai-assist:hover, #ai-assist.thinking {
  opacity: 1;
}
#ai-assist header {
  border-bottom: 1px solid var(--chat_header_color, #e3e6f0);
  padding-bottom: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
#ai-assist header .main-zone {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
}
#ai-assist header .main-zone app-loader {
  margin-left: 10px;
}
#ai-assist header .main-zone h2 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
}
#ai-assist header .minimize-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted, #6c757d);
  transition: all 0.2s ease;
}
#ai-assist header .minimize-btn:hover {
  background: rgba(0, 0, 0, 0.1);
  color: var(--text-primary, #333);
}
#ai-assist header .minimize-btn i {
  font-size: 0.8rem;
}
#ai-assist header .close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted, #6c757d);
  transition: all 0.2s ease;
}
#ai-assist header .close-btn:hover {
  background: rgba(255, 0, 0, 0.1);
  color: #ff0000;
}
#ai-assist header .close-btn i {
  font-size: 0.8rem;
}
#ai-assist.minimized {
  height: auto;
}
#ai-assist.minimized header {
  border-bottom: none;
  padding-bottom: 0;
}
#ai-assist .entry-list {
  padding-top: 0.5rem;
  flex: 1;
  overflow-y: auto;
  scroll-behavior: smooth;
}
#ai-assist .entry-list::-webkit-scrollbar {
  width: 4px;
}
#ai-assist .entry-list::-webkit-scrollbar-track {
  background: transparent;
}
#ai-assist .entry-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}
#ai-assist .entry-list::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
#ai-assist .entry-list .entry {
  margin-bottom: 1rem;
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 15px;
  padding: 10px;
  transition: background-color 0.3s ease;
  position: relative;
}
#ai-assist .entry-list .entry:hover {
  background-color: #f8f8f8;
}
#ai-assist .entry-list .entry p {
  margin: 0 0 0.5rem 0;
  font-size: 0.85rem;
  line-height: 1.4;
}
#ai-assist .entry-list .entry.with-knowledge {
  padding-right: 25px;
}
#ai-assist .entry-list .entry .knowledge-attached {
  position: absolute;
  right: 5px;
  top: 5px;
  color: var(--primary-color);
}
#ai-assist .entry-list .entry.with-suggestions {
  border-left: 3px solid var(--primary-color, #4f46e5);
  background: rgba(79, 70, 229, 0.05);
  cursor: pointer;
  transition: all 0.2s ease;
}
#ai-assist .entry-list .entry.with-suggestions:hover {
  background: rgba(79, 70, 229, 0.1);
  transform: translateX(2px);
}
#ai-assist .entry-list .entry.with-suggestions p {
  position: relative;
  cursor: pointer;
}
#ai-assist .content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
#ai-assist .content .entry-list {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
#ai-assist .content ai-suggestions {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}`;
const shadowOptions = { "mode": "open" };
let AIAssistComponent = class AIAssistComponent extends client_1.RWSViewComponent {
    constructor(signalService, apiService, storageService, htmlStripService) {
        super();
        this.signalService = signalService;
        this.apiService = apiService;
        this.storageService = storageService;
        this.htmlStripService = htmlStripService;
        this.entries = [];
        this.activeEntry = null;
        this.minimized = true;
        this.thinking = false;
        this.currentContext = [];
        this.proposedKnowledgeIds = [];
        this.isLLMStreaming = false;
        this.currentSuggestions = [];
        this.isEnabled = true;
        this.selectEntryTimeout = null;
        // Initialize state with minimal defaults
        // Full initialization happens in connectedCallback when all services are available
        this.componentState = helpers_1.AIAssistStateManager.createInitialState();
        this.contextState = helpers_1.AIAssistContextManager.createInitialState();
        this.inputState = helpers_1.AIAssistInputHandler.createInitialState();
        // Sync observable properties with state
        this.syncStateToObservables();
    }
    async connectedCallback() {
        super.connectedCallback();
        // Ensure state is initialized before proceeding
        if (!this.componentState || !this.contextState || !this.inputState) {
            return;
        }
        // Now that services are available, update the enabled state properly
        if (this.storageService) {
            this.componentState = helpers_1.AIAssistStateManager.updateEnabledState(this.componentState, this.storageService);
            this.isEnabled = this.componentState.isEnabled;
        }
        // Initialize signals with callbacks
        const signalContext = {
            signalService: this.signalService,
            onAssistantSignal: this.onAssistantSignal.bind(this),
            onActiveEntryChange: (entry) => this.updateActiveEntry(entry),
            onKnowledgePickerOpen: () => {
                helpers_1.AIAssistSignalManager.sendKnowledgeOpenSignal();
            },
            onKnowledgePickerOpenCreate: () => {
                helpers_1.AIAssistSignalManager.sendKnowledgeOpenCreateSignal();
            },
            onKnowledgeFileCreate: (payload) => {
                helpers_1.AIAssistSignalManager.sendKnowledgeCreateSignal(payload);
            },
            onKnowledgeFileAttach: (kdbId) => {
                helpers_1.AIAssistSignalManager.sendKnowledgeAttachSignal([kdbId]);
            },
            onRefreshSettings: () => this.refreshEnabledState()
        };
        helpers_1.AIAssistSignalManager.initializeSignals(signalContext, this.componentState.isEnabled);
    }
    // Sync internal state to observable properties
    syncStateToObservables() {
        if (!this.componentState || !this.contextState || !this.inputState) {
            return;
        }
        this.entries = this.componentState.entries;
        this.activeEntry = this.componentState.activeEntry;
        this.minimized = this.componentState.minimized;
        this.thinking = this.componentState.thinking;
        this.currentContext = this.contextState.currentContext;
        this.proposedKnowledgeIds = this.componentState.proposedKnowledgeIds;
        this.isLLMStreaming = this.componentState.isLLMStreaming;
        this.currentSuggestions = this.componentState.currentSuggestions;
        this.isEnabled = this.componentState.isEnabled;
    }
    async onAssistantSignal(signal) {
        try {
            if (signal) {
                const context = {
                    entries: this.entries,
                    activeEntry: this.activeEntry,
                    minimized: this.minimized,
                    proposedKnowledgeIds: this.proposedKnowledgeIds,
                    currentContext: this.currentContext,
                    reactionTimeout: this.inputState.reactionTimeout,
                    ensureScrollToBottom: this.ensureScrollToBottom.bind(this)
                };
                const updatedContext = helpers_1.AIAssistSignalHelper.processSignal(signal, context);
                this.applySignalUpdates(updatedContext);
            }
        }
        catch (error) {
            console.error('AI Assist: Error processing signal:', error);
            this.handleError();
        }
    }
    applySignalUpdates(context) {
        if (!this.componentState || !this.contextState || !this.inputState)
            return;
        this.componentState = helpers_1.AIAssistStateManager.mergeState(this.componentState, {
            entries: context.entries,
            activeEntry: context.activeEntry,
            minimized: context.minimized,
            proposedKnowledgeIds: context.proposedKnowledgeIds
        });
        this.contextState = helpers_1.AIAssistContextManager.updateContextSafe(context.currentContext, this.htmlStripService, this.contextState);
        this.inputState.reactionTimeout = context.reactionTimeout;
        this.syncStateToObservables();
    }
    updateActiveEntry(entry) {
        if (!this.componentState)
            return;
        this.componentState = helpers_1.AIAssistStateManager.setActiveEntry(this.componentState, entry);
        this.activeEntry = this.componentState.activeEntry;
    }
    // UI Event Handlers
    selectEntry(entry) {
        if (!this.componentState)
            return;
        if (this.selectEntryTimeout) {
            clearTimeout(this.selectEntryTimeout);
        }
        this.componentState = helpers_1.AIAssistStateManager.setActiveEntry(this.componentState, null);
        this.activeEntry = null;
        this.selectEntryTimeout = setTimeout(() => {
            if (!this.componentState)
                return;
            this.componentState = helpers_1.AIAssistStateManager.setActiveEntry(this.componentState, entry);
            this.activeEntry = this.componentState.activeEntry;
            const suggestionState = helpers_1.AIAssistSuggestionHandler.createSuggestionState(entry, true);
            this.updateSuggestionDisplay(suggestionState);
            this.selectEntryTimeout = null;
        }, 0);
    }
    updateSuggestionDisplay(suggestionState) {
        if (!this.componentState)
            return;
        this.componentState = helpers_1.AIAssistStateManager.setCurrentSuggestions(this.componentState, suggestionState.suggestions);
        this.currentSuggestions = this.componentState.currentSuggestions;
        if (suggestionState.showingFullwidth) {
            this.classList.add('showing-suggestions-fullwidth');
        }
        else {
            this.classList.remove('showing-suggestions-fullwidth');
        }
    }
    onSuggestionApplied(event) {
        const { suggestion, text } = event.detail;
        const suggestionContext = {
            chatInputSource: this.inputState.chatInputSource,
            emitEvent: this.$emit.bind(this)
        };
        helpers_1.AIAssistSuggestionHandler.handleSuggestionApplied(suggestion, text, this.activeEntry, suggestionContext);
        this.clearSuggestionsDisplay();
    }
    onSuggestionsApplied(event) {
        const { text, isMultiple } = event.detail;
        const suggestionContext = {
            chatInputSource: this.inputState.chatInputSource,
            emitEvent: this.$emit.bind(this)
        };
        console.log('input-this');
        helpers_1.AIAssistSuggestionHandler.handleMultipleSuggestionsApplied(text, isMultiple, suggestionContext);
        this.clearSuggestionsDisplay();
    }
    onSuggestionsClose() {
        this.clearSuggestionsDisplay();
    }
    clearSuggestionsDisplay() {
        if (!this.componentState)
            return;
        this.componentState = helpers_1.AIAssistStateManager.clearCurrentSuggestions(this.componentState);
        this.activeEntry = null;
        this.currentSuggestions = [];
        this.classList.remove('showing-suggestions-fullwidth');
    }
    toggleMinimize() {
        if (!this.componentState)
            return;
        this.componentState = helpers_1.AIAssistStateManager.toggleMinimized(this.componentState);
        this.minimized = this.componentState.minimized;
    }
    // Input Handling
    bindInputSource(input) {
        var _a;
        try {
            if (!((_a = this.componentState) === null || _a === void 0 ? void 0 : _a.isEnabled))
                return;
            const context = this.createInputHandlerContext();
            const callbacks = this.createInputHandlerCallbacks();
            if (!context || !callbacks)
                return;
            this.inputState = helpers_1.AIAssistInputHandler.bindInputSource(input, this.inputState, context, callbacks);
        }
        catch (error) {
            console.error('AI Assist: Error binding input source:', error);
            this.handleError();
        }
    }
    createInputHandlerContext() {
        if (!this.componentState || !this.contextState) {
            return null;
        }
        return {
            isEnabled: this.componentState.isEnabled,
            thinking: this.componentState.thinking,
            isLLMStreaming: this.componentState.isLLMStreaming,
            currentContext: this.contextState.currentContext,
            proposedKnowledgeIds: this.componentState.proposedKnowledgeIds,
            assistantSignal: helpers_1.AIAssistSignalManager.getAssistantSignal(),
            minimized: this.componentState.minimized,
            apiService: this.apiService
        };
    }
    createInputHandlerCallbacks() {
        if (!this.componentState) {
            return null;
        }
        return {
            onThinkingChange: (thinking) => {
                if (!this.componentState)
                    return;
                this.componentState = helpers_1.AIAssistStateManager.setThinking(this.componentState, thinking);
                this.thinking = this.componentState.thinking;
            },
            onKnowledgeIdsChange: (ids) => {
                if (!this.componentState)
                    return;
                this.componentState = helpers_1.AIAssistStateManager.setProposedKnowledgeIds(this.componentState, ids);
                this.proposedKnowledgeIds = this.componentState.proposedKnowledgeIds;
            },
            onMinimizedChange: (minimized) => {
                if (!this.componentState)
                    return;
                this.componentState = helpers_1.AIAssistStateManager.setMinimized(this.componentState, minimized);
                this.minimized = this.componentState.minimized;
            }
        };
    }
    // Context Management
    updateContextFromMessages(messages) {
        const context = this.createInputHandlerContext();
        const callbacks = this.createInputHandlerCallbacks();
        if (!context || !callbacks)
            return;
        helpers_1.AIAssistInputHandler.updateContextFromMessages(messages, this.inputState, context, callbacks, (convertedMessages) => {
            if (!this.contextState)
                return;
            // Update context state with the already converted messages
            // Use updateContextSafe to avoid duplicate message processing
            this.contextState = helpers_1.AIAssistContextManager.updateContextSafe(convertedMessages, this.htmlStripService, this.contextState);
            this.currentContext = this.contextState.currentContext;
            // Update signal context
            this.updateContext(convertedMessages);
        });
    }
    setLLMStreaming(streaming) {
        if (!this.componentState || !this.contextState || !this.inputState)
            return;
        this.componentState = helpers_1.AIAssistStateManager.setLLMStreaming(this.componentState, streaming);
        this.contextState = helpers_1.AIAssistContextManager.setLLMStreaming(this.contextState, streaming);
        this.inputState = helpers_1.AIAssistInputHandler.setLLMStreaming(streaming, this.inputState);
        this.isLLMStreaming = this.componentState.isLLMStreaming;
    }
    // Public API Methods
    async analyzeCurrentContext() {
        try {
            const context = this.createInputHandlerContext();
            const callbacks = this.createInputHandlerCallbacks();
            if (!context || !callbacks)
                return;
            await helpers_1.AIAssistInputHandler.analyzeCurrentContext(context, callbacks);
        }
        catch (error) {
            console.error('AI Assist: Error during context analysis:', error);
            this.handleError();
        }
    }
    async analyzeAfterLLMResponse() {
        try {
            const context = this.createInputHandlerContext();
            const callbacks = this.createInputHandlerCallbacks();
            if (!context || !callbacks)
                return;
            await helpers_1.AIAssistInputHandler.analyzeAfterLLMResponse(context, callbacks);
        }
        catch (error) {
            console.error('AI Assist: Error during post-LLM analysis:', error);
            this.handleError();
        }
    }
    // Error handling and recovery
    handleError() {
        var _a;
        // Turn off loading/thinking state
        if (this.componentState) {
            this.componentState = helpers_1.AIAssistStateManager.setThinking(this.componentState, false);
            this.thinking = false;
        }
        // Clear any active entry to close suggestions modal
        this.clearSuggestionsDisplay();
        // Minimize the component to get it out of the way
        if (this.componentState && !this.componentState.minimized) {
            this.componentState = helpers_1.AIAssistStateManager.setMinimized(this.componentState, true);
            this.minimized = true;
        }
        // Clear any pending timeouts
        if ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.reactionTimeout) {
            clearTimeout(this.inputState.reactionTimeout);
            this.inputState.reactionTimeout = null;
        }
    }
    // Convenience methods for external components
    addEntry(entry) {
        const assistantSignal = helpers_1.AIAssistSignalManager.getAssistantSignal();
        if (assistantSignal) {
            helpers_1.AIAssistSignalHelper.addEntry(assistantSignal, entry);
        }
    }
    clearEntries() {
        const assistantSignal = helpers_1.AIAssistSignalManager.getAssistantSignal();
        if (assistantSignal) {
            helpers_1.AIAssistSignalHelper.clearEntries(assistantSignal);
        }
    }
    updateContext(context) {
        const assistantSignal = helpers_1.AIAssistSignalManager.getAssistantSignal();
        if (assistantSignal) {
            helpers_1.AIAssistSignalHelper.updateContext(assistantSignal, context);
        }
    }
    // Context helper methods
    prepareApiContext(maxMessages = 20, maxLength = 4000) {
        if (!this.contextState)
            return null;
        return helpers_1.AIAssistContextManager.prepareApiContext(this.contextState.currentContext, this.htmlStripService, {
            maxMessages,
            maxLength,
            stripHtml: true
        });
    }
    addEntrySafe(entry) {
        if (!this.componentState)
            return;
        const cleanedEntry = {
            ...entry,
            text: entry.text ? this.htmlStripService.sanitizeAssistantMessage(entry.text) : entry.text
        };
        this.componentState = helpers_1.AIAssistStateManager.addEntry(this.componentState, cleanedEntry);
        this.entries = this.componentState.entries;
    }
    // Utility methods
    getExternalSignal() {
        return helpers_1.AIAssistSignalManager.getExternalSignal();
    }
    refreshEnabledState() {
        if (!this.componentState)
            return;
        const previousState = this.componentState.isEnabled;
        this.componentState = helpers_1.AIAssistStateManager.updateEnabledState(this.componentState, this.storageService);
        this.isEnabled = this.componentState.isEnabled;
        if (!previousState && this.componentState.isEnabled) {
            const signalContext = {
                signalService: this.signalService,
                onAssistantSignal: this.onAssistantSignal.bind(this),
                onActiveEntryChange: (entry) => this.updateActiveEntry(entry),
                onKnowledgeFileCreate: (payload) => {
                    helpers_1.AIAssistSignalManager.sendKnowledgeCreateSignal(payload);
                },
                onKnowledgeFileAttach: (kdbId) => {
                    helpers_1.AIAssistSignalManager.sendKnowledgeAttachSignal([kdbId]);
                },
                onRefreshSettings: () => this.refreshEnabledState(),
                onKnowledgePickerOpen: () => {
                    helpers_1.AIAssistSignalManager.sendKnowledgeOpenSignal();
                },
                onKnowledgePickerOpenCreate: () => {
                    helpers_1.AIAssistSignalManager.sendKnowledgeOpenCreateSignal();
                }
            };
            helpers_1.AIAssistSignalManager.setupSignalsOnEnable(signalContext);
        }
    }
    // DOM Helper methods
    ensureScrollToBottom() {
        helpers_1.AIAssistDOMHelper.ensureScrollToBottom(this.shadowRoot);
    }
    minimizedChanged(oldValue, newValue) {
        helpers_1.AIAssistDOMHelper.toggleMinimizedClass(this.shadowRoot, newValue);
    }
    entriesChanged(oldValue, newValue) {
        if (!this.componentState) {
            return;
        }
        const newState = helpers_1.AIAssistStateManager.handleEntriesChange(oldValue || [], newValue, this.componentState);
        if (newState.activeEntry !== this.componentState.activeEntry) {
            this.componentState = newState;
            setTimeout(() => {
                this.selectEntry(newState.activeEntry);
            }, 10);
        }
    }
    activeEntryChanged(oldValue, newValue) {
        const externalSignal = helpers_1.AIAssistSignalManager.getExternalSignal();
        if (externalSignal) {
            externalSignal.setValue({
                command: assistant_component_types_1.AssistantSignalCommand.PASS_ENTRY,
                payload: newValue
            });
        }
    }
    getSuggestionsContext() {
        const context = {
            lastMessage: undefined,
            inputPrompt: undefined,
            isFromInput: false
        };
        // Use actual chat context messages instead of AI assist entries
        if (this.currentContext && this.currentContext.length > 0) {
            // Get the last message from the chat context
            const lastMessage = this.currentContext[this.currentContext.length - 1];
            if (lastMessage) {
                // Extract text content, handling both string and array formats
                let messageContent = '';
                if (typeof lastMessage.content === 'string') {
                    messageContent = lastMessage.content;
                }
                else if (Array.isArray(lastMessage.content)) {
                    // For array content, extract text from message parts
                    messageContent = lastMessage.content
                        .map(part => typeof part === 'string' ? part : part.text || '')
                        .join(' ');
                }
                context.lastMessage = messageContent;
                // Determine if this was from user input based on the role
                context.isFromInput = lastMessage.role === 'user';
                // If it's a user message, also set it as inputPrompt
                if (context.isFromInput) {
                    context.inputPrompt = messageContent;
                }
            }
        }
        return context;
    }
};
exports.AIAssistComponent = AIAssistComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AIAssistComponent.prototype, "entries", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof assistant_component_types_1.IAssistEntry !== "undefined" && assistant_component_types_1.IAssistEntry) === "function" ? _e : Object)
], AIAssistComponent.prototype, "activeEntry", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AIAssistComponent.prototype, "minimized", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AIAssistComponent.prototype, "thinking", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AIAssistComponent.prototype, "currentContext", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AIAssistComponent.prototype, "proposedKnowledgeIds", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AIAssistComponent.prototype, "isLLMStreaming", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AIAssistComponent.prototype, "currentSuggestions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AIAssistComponent.prototype, "isEnabled", void 0);
exports.AIAssistComponent = AIAssistComponent = __decorate([
    (0, client_1.RWSView)('ai-assist', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(SignalService_1.default)),
    __param(1, (0, client_1.RWSInject)(client_1.ApiService)),
    __param(2, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(3, (0, client_1.RWSInject)(HtmlStripService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _a : Object, typeof (_b = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _b : Object, typeof (_c = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _c : Object, typeof (_d = typeof HtmlStripService_1.HTMLStripServiceInstance !== "undefined" && HtmlStripService_1.HTMLStripServiceInstance) === "function" ? _d : Object])
], AIAssistComponent);
AIAssistComponent.defineComponent();
